import Mainvisual from "./mainvisual.es6";
//import Form from "./form.es6";
import ModalThx from "./modal_thx.es6";
import Confetti from "./confetti.es6";

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.mainvisual = new Mainvisual();
        //this.form = new Form();
        this.modalthx = new ModalThx();
        this.confetti = new Confetti();
    }
}
